import { RpgConfigAiGeneration, RpgConfigProperty } from '@common/studio-types';
import { dimensions, textStyles } from '@maestro/styles';
import React from 'react';
import styled from 'styled-components';
import { AiGenerationQuickAdd } from './AiGenerationQuickAdd';

type Props = {
  onCreateElement: (element: RpgConfigAiGeneration) => void;
  properties: RpgConfigProperty[];
};

export const AiGenerationEmptyState: React.FC<Props> = (props) => {
  const { onCreateElement, properties } = props;

  return (
    <EmptyState>
      <EmptyStateText>
        <EmptyStateTitle>
          There are no properties configured for AI generation
        </EmptyStateTitle>
        <EmptyStateDescription>
          These properties will show up to the users, they will be able to fill
          the form to generate a new episode based on this template
        </EmptyStateDescription>
      </EmptyStateText>
      <AiGenerationQuickAdd
        properties={properties}
        onCreateElement={onCreateElement}
      />
    </EmptyState>
  );
};

const EmptyState = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  flex-direction: column;
  gap: ${dimensions.size24};
  padding: ${dimensions.size16};
  text-align: center;
  max-width: ${dimensions.size600};
  margin: 0 auto;
`;

const EmptyStateText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${dimensions.size8};
  text-align: center;
`;

const EmptyStateTitle = styled.div`
  ${textStyles.label.lb16sb}
  color: ${({ theme }) => theme.colors.text.header};
`;

const EmptyStateDescription = styled.div`
  ${textStyles.body.b14m}
  color: ${({ theme }) => theme.colors.text.body};
`;
